<template>
  <div id="myDateShow">
    <div class="title">{{isAdd?'查看':'新增'}} 角色</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">角色名称</div>
        <div class="value">
          <el-input style="width: 500px;" v-model="role.roleName" placeholder="请填写角色名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">角色权限</div>
        <div class="value">
          <el-tree
                  ref="tree"
                  :data="roleTree"
                  show-checkbox
                  check-on-click-node
                  check-strictly
                  default-expand-all
                  :default-checked-keys="defaultClick"
                  @check-change="treeClick"
                  node-key="id">
          </el-tree>
        </div>
      </div>
      <div class="line">
        <div class="key">保存权限信息</div>
        <div class="value">
          <el-button type="primary" size="small" @click="submit">保存</el-button>
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getRole,updateRole,newVue} from "../../network/admin";

  export default {
    name: "RoleData",
    computed: {
      defaultClick(){
        let arr = [];
        let resources = this.role.roleResources;
        if (resources==null){
          resources = [];
        }
        for (let i = 0;i<this.role.roleResources.length;i++){
          arr.push(resources[i].resourcesId)
        }
        return arr;
      }
    },
    data(){
      return{
        role:{
          roleResources:[],
          resources: []
        },
        isAdd: false,
        roleTree:[
          {
            id: 1000,
            label: '注册会员管理',
            disabled: true,
            children: [
              {
                id: 1001,
                label:"会员资料管理",
                disabled: true,
                children: [
                  {
                    id: 86,
                    label: '查询密码'
                  },
                  {
                    id: 82,
                    label: '冻结用户'
                  },
                  {
                    id: 83,
                    label: '解冻用户'
                  },
                  {
                    id: 84,
                    label: '永久禁用用户'
                  }
                ]
              }
            ]
          },
          {
            id: 1002,
            label: '农基商管理',
            disabled: true,
            children:[
              {
                id: 1003,
                label: '农基商资料管理',
                disabled: true,
                children: [
                  {
                    id: 19,
                    label: '新增/修改农基商'
                  },
                  {
                    id: 18,
                    label: '删除农基商'
                  }
                ]
              }
            ]
          },
          {
            id: 1024,
            label: '心坞栈管理',
            disabled: true,
            children: [
              {
                id: 1024,
                label: '心坞栈管理',
                disabled: true,
                children: [
                  {
                    id: 161,
                    label: '心坞栈所有相关权限'
                  }
                ]
              }
            ]
          },
          {
            id: 1004,
            label: '农商品管理',
            disabled: true,
            children: [
              {
                id: 1005,
                label: 'earth_plan管理',
                disabled: true,
                children: [
                  {
                    id: 70,
                    label: '新增/修改商品'
                  },
                  {
                    id: 71,
                    label: '删除商品'
                  },
                  {
                    id: 72,
                    label: '下架商品'
                  },
                  {
                    id: 73,
                    label: '上架商品'
                  },
                  {
                    id: 74,
                    label: '封仓商品'
                  }
                ]
              },
              // {
              //   id: 1006,
              //   label: '心味厨房管理',
              //   disabled: true,
              //   children: [
              //     {
              //       id: 97,
              //       label: '新增/修改视频'
              //     },
              //     {
              //       id: 100,
              //       label: '删除视频'
              //     },
              //     {
              //       id: 101,
              //       label: '上线视频'
              //     },
              //     {
              //       id: 102,
              //       label: '下线视频'
              //     },
              //   ]
              // },
              {
                id: 1007,

                label: '每日精选管理',
                disabled: true,
                children: [
                  {
                    id: 9,
                    label: '新增精选'
                  },
                  {
                    id: 11,
                    label: '删除精选'
                  }
                ]
              },
              {
                id: 1008,
                label: '轮播图管理',
                disabled: true,
                children: [
                  {
                    id: 76,
                    label: '新增商品轮播'
                  },
                  {
                    id: 77,
                    label: '增加/修改新的活动轮播'
                  },
                  {
                    id: 78,
                    label: '删除轮播商品'
                  }
                ]
              },
              {
                id: 1013,
                label: '商品标签管理',
                disabled: true,
                children: [
                  {
                    id: 59,
                    label: '新增/修改标签'
                  },
                  {
                    id: 58,
                    label: '删除标签'
                  }
                ]
              }
            ]
          },
          {
            id: 1009,
            label: '订单管理',
            disabled: true,
            children:[
              {
                id: 1010,
                label: '订单资料管理',
                disabled: true,
                children: [
                  {
                    id: 29,
                    label: '订单发货'
                  },
                  {
                    id: 32,
                    label: '作废订单'
                  },
                  {
                    id: 33,
                    label: '检查订单状态'
                  },
                  {
                    id: 51,
                    label: '同意退款申请'
                  },
                  {
                    id: 52,
                    label: '拒绝退款申请'
                  },
                ]
              }
            ]
          },
          {
            id: 1020,
            label: '营销俱乐部管理',
            disabled: true,
            children:[
              {
                id: 1021,
                label: '营销商户列表管理',
                disabled: true,
                children: [
                  {
                    id: 142,
                    label: '新增/修改商户的信息'
                  },
                  {
                    id: 144,
                    label: '删除商户信息'
                  }
                ]
              },
              {
                id: 1022,
                label: '营销活动列表管理',
                disabled: true,
                children: [
                  {
                    id: 147,
                    label: '新增/修改活动的信息'
                  }
                ]
              },
              {
                id: 1023,
                label: '营销活动用户答案列表管理',
                disabled: true,
                children: [
                  {
                    id: 152,
                    label: '选为中奖'
                  },
                  {
                    id: 153,
                    label: '取消中奖'
                  }
                ]
              },
            ]
          },
          {
            id: 1016,
            label: '卡券管理',
            disabled: true,
            children:[
              {
                id: 1017,
                label: '绿能券列表管理',
                disabled: true,
                children: [
                  {
                    id: 119,
                    label: '新增/修改优惠券信息'
                  }
                ]
              },
            ]
          },
          {
            id: 1011,
            label: '系统信息管理',
            disabled: true,
            children:[
              {
                id: 1012,
                label: '系统信息管理',
                disabled: true,
                children: [
                  {
                    id: 20,
                    label: '新增/修改系统信息'
                  },
                  {
                    id: 22,
                    label: '删除系统消息'
                  }
                ]
              },
              {
                id: 1018,
                label: '版本信息管理',
                disabled: true,
                children: [
                  {
                    id: 127,
                    label: '新增/修改版本信息'
                  },
                  {
                    id: 129,
                    label: '删除版本消息'
                  }
                ]
              },
              {
                id: 1019,
                label: '条款信息管理',
                disabled: true,
                children: [
                  {
                    id: 133,
                    label: '修改条款信息'
                  }
                ]
              }
            ]
          },
          {
            id: 1014,
            label: '平台管理员管理',
            disabled: true,
            children:[
              {
                id: 1015,
                label: '管理员管理',
                disabled: true,
                children: [
                  {
                    id: 1,
                    label: '新增/修改管理员'
                  },
                  {
                    id: 3,
                    label: '新增/修改角色信息'
                  },
                  {
                    id: 5,
                    label: '删除管理员'
                  }
                ]
              }
            ]
          },
        ]
      }
    },
    methods:{
      submit(){
        let resArr = this.$refs.tree.getCheckedNodes();
        let resArrPath = [];
        for (let i = 0;i<resArr.length;i++){
          let resources = {};
          resources.id = resArr[i].id;
          resArrPath.push(resources)
        }
        this.role.resources = resArrPath;
        updateRole(this.role).then(res => {
          console.log(res);
        })
      },
      backClick(){
        this.$router.back();
      },
      treeClick(a,b){
        console.log(a,b)
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/admin/list";
      this.common.HeaderLocationTwo.name =  "平台管理员管理"
      this.common.HeaderLocationThree.name = "角色详情"
      let role = getRole();
      if (role!=null){
        this.isAdd = true
        this.role = role
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
